import { isString } from "@sinch/feature-flags";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { useEffect, useState } from "react";
import { z } from "zod";
import { useFetchUser } from "../../../api/hooks/useUser";
import { safeRetrieveValue } from "../../../helpers/safeRetrieveValue";
import { fetchUserDetails } from "../requests";
import { useMmToken } from "./useMMToken";

dayjs.extend(utc);
dayjs.extend(timezone);

export const userDetailsZod = z.object({
  summaries: z.array(z.any()),
  total_sent: z.number(),
  total_received: z.number(),
  total_billing_units: z.number(),
  total_opt_out: z.number(),
});
export type UserDetails = z.infer<typeof userDetailsZod>;

export const useUserDetails = () => {
  const [mmUser] = useFetchUser();
  const accessToken = useMmToken();

  const [userDetails, setUserDetails] = useState<UserDetails>();

  const initUserDetails = async (token: string, username: string) => {
    const response = await fetchUserDetails(token, username);
    const parsed = userDetailsZod.safeParse(response);
    if (parsed.success) {
      setUserDetails(parsed.data);
    } else {
      console.error("fetchUserDetails_failedToParse: ", parsed.error);
    }
  };

  useEffect(() => {
    const userName =
      mmUser?.settings &&
      safeRetrieveValue(mmUser.settings, "username", isString);
    if (userName && accessToken) {
      initUserDetails(accessToken, userName);
    }
  }, [mmUser, accessToken]);

  return userDetails;
};
